/**
 * PDP Additional Slider
 * Pure CSS flex scroller with manually wired prev/next arrows.
 * No jQuery / Slick — avoids slide cloning so the PLP card JS
 * (initialize-gallery.js, swatches, quick view) keeps working.
 */
if (!customElements.get('pdp-additional-sliders')) {
  customElements.define(
    'pdp-additional-sliders',
    class PdpAdditionalSliders extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init());
        } else {
          this.init();
        }
      }

      init() {
        this.slider = this.querySelector('.style-recommendations-slider');
        if (!this.slider) return;

        // Arrows live in the section header (.hdr_arrow)
        const container = this.slider.closest('.style-recommendations');
        this.prevArrow = container ? container.querySelector('.pre_arrow') : null;
        this.nextArrow = container ? container.querySelector('.next_arrow') : null;
        this.arrowWrap = container ? container.querySelector('.hdr_arrow') : null;

        this.updateArrowVisibility();

        if (this.prevArrow) {
          this.prevArrow.addEventListener('click', () => this.scrollByCards(-1));
        }
        if (this.nextArrow) {
          this.nextArrow.addEventListener('click', () => this.scrollByCards(1));
        }

        // Recompute arrow state on scroll / resize
        this.slider.addEventListener('scroll', () => this.updateArrowState(), { passive: true });
        window.addEventListener('resize', () => {
          this.updateArrowVisibility();
          this.updateArrowState();
        });

        this.updateArrowState();
      }

      /* Width of a single card + gap, used to page the scroller */
      getStep() {
        const firstItem = this.slider.querySelector('.grid__item');
        if (!firstItem) return this.slider.clientWidth;
        const style = window.getComputedStyle(this.slider);
        const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
        return firstItem.getBoundingClientRect().width + gap;
      }

      scrollByCards(direction) {
        const step = this.getStep();
        this.slider.scrollBy({ left: step * direction, behavior: 'smooth' });
      }

      /* Hide arrows entirely when every card already fits without scrolling */
      updateArrowVisibility() {
        if (!this.arrowWrap) return;
        const needsScroll = this.slider.scrollWidth > this.slider.clientWidth + 2;
        this.arrowWrap.classList.toggle('hidden', !needsScroll);
      }

      /* Dim arrows at the start / end of the scroll range */
      updateArrowState() {
        const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
        const x = this.slider.scrollLeft;

        if (this.prevArrow) {
          this.prevArrow.classList.toggle('is-disabled', x <= 2);
        }
        if (this.nextArrow) {
          this.nextArrow.classList.toggle('is-disabled', x >= maxScroll - 2);
        }
      }
    }
  );
}
